/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Preview_Home_PageInputs */

const en_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview Home Page`)
};

const de_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage-Vorschau`)
};

const es_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de la página de inicio`)
};

const fr_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu de la page d'accueil`)
};

const it_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima home page`)
};

const pt_br2_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizar página inicial`)
};

const pl_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podgląd strony głównej`)
};

const hu_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Főoldal előnézete`)
};

const ro_admin_dashboard_preview_home_page = /** @type {(inputs: Admin_Dashboard_Preview_Home_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previzualizare Pagina de Start`)
};

/**
* | output |
* | --- |
* | "Preview Home Page" |
*
* @param {Admin_Dashboard_Preview_Home_PageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_preview_home_page = /** @type {((inputs?: Admin_Dashboard_Preview_Home_PageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Preview_Home_PageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_preview_home_page(inputs)
	if (locale === "de") return de_admin_dashboard_preview_home_page(inputs)
	if (locale === "es") return es_admin_dashboard_preview_home_page(inputs)
	if (locale === "fr") return fr_admin_dashboard_preview_home_page(inputs)
	if (locale === "it") return it_admin_dashboard_preview_home_page(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_preview_home_page(inputs)
	if (locale === "pl") return pl_admin_dashboard_preview_home_page(inputs)
	if (locale === "hu") return hu_admin_dashboard_preview_home_page(inputs)
	return ro_admin_dashboard_preview_home_page(inputs)
});
export { admin_dashboard_preview_home_page as "admin.dashboard.preview_home_page" }